import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';
import { FacilityTypeEnum } from '../contracts';

export const GetResidentByIdRequestDtoSchema = z.object({
  residentId: z.number(),
});

export const PayPositionCategorySchema = z.enum([
  'UNDERPAYING',
  'ON_TARGET',
  'OVERPAYING',
]);

export const GetResidentByIdResponseDtoSchema = z.object({
  activeAlerts: z.number(),
  avatarUrl: z.string().nullable(),
  careHistory: z.array(
    z.object({
      evaluationDate: z.string(),
      careLevelName: z.string(),
    })
  ),
  careLevelName: z.string().nullable(),
  careLevelPoints: z.number().nullable(),
  createdAlerts: z.number(),
  createdFlags: z.number(),
  dob: z.coerce.date(),
  evaluationStatus: z.string(),
  facilityName: z.string(),
  facilityTypes: z.array(FacilityTypeEnum),
  notAssignedToRoom: z.boolean().default(false),
  floor: z.string(),
  fullName: z.string(),
  hall: z.string(),
  id: z.number(),
  medicaidPayer: z.string().nullable(),
  lengthOfStay: z.number(),
  moveInDate: z.string().nullable(),
  payerType: z.string().nullable(),
  rate: z.number(),
  revenue: z.number(),
  reviewDate: z.coerce.date(),
  room: z.string(),
  roomType: z.string(),
  medianRate: z.number().nullable(),
  payPositionPct: z.number().nullable(),
  payPosition: PayPositionCategorySchema.nullable(),
});

export type GetResidentByIdRequestDto = z.infer<
  typeof GetResidentByIdRequestDtoSchema
>;
export type GetResidentByIdResponseDto = z.infer<
  typeof GetResidentByIdResponseDtoSchema
>;

export const getResidentById = async (
  params: GetResidentByIdRequestDto,
  config?: AxiosRequestConfig<GetResidentByIdRequestDto>
) => {
  const { residentId } = params;

  return await api
    .get(`/residents/${residentId}`, { ...config })
    .then(responseContract(GetResidentByIdResponseDtoSchema));
};
